import { CrmOrg } from '../../../../types/CrmOrgs';
import WithConnectOrgPermission from '../../../common/WithConnectOrgPermission';
import { FetchStatus } from '@server/fetch_status.type';
import { UNAUTHORIZED_FETCH_TOOLTIP } from '../../../../constants';
import WithPermissions from '../../../common/WithPermissions';
import { isOrgConnectionError } from '../../../../hooks/global-reducer/environmentsHelper';
import { Button } from '@sweep-io/sweep-design';
import { CenteredCircularProgress } from '../../../common/CenteredCircularProgress';
import { useCrmOrgs } from '../useCrmOrgs';
import { getCrmOrgConnectionErrorData } from '../../get-started/connect-org/getCrmOrgConnectionErrorData';
import { useSweepNotifications } from '../../../notifications/useSweepNotifications';
import { SweepNotificationVariant } from '../../../../reducers/notificationsReducer';
import { EnvironmentTypes } from '../EnvironmentTypeEnum';
import { useFeatureToggle } from '../../../../feature-flags/useFeatureToggle';

export const RefreshOrReconnect = ({ env }: { env: CrmOrg }) => {
  const { environmentsPage } = useFeatureToggle();
  const hasError = isOrgConnectionError(env.fetchStatus);
  const { fetchOrg, connectOrg } = useCrmOrgs();
  const { addNotification } = useSweepNotifications();
  const isFetching = [FetchStatus.Fetching, FetchStatus.InitialFetching].includes(env.fetchStatus);

  const refreshHandler = async () => {
    await fetchOrg(env);
  };

  const reconnectHandler = async () => {
    const result = await connectOrg({
      crmOrgToReconnect: env,
      type: env.isSandbox ? EnvironmentTypes.Sandbox : EnvironmentTypes.Production,
    });
    if (result.result === 'error') {
      const { description, title } = getCrmOrgConnectionErrorData({
        error: result.error,
      });
      addNotification({
        message: title,
        details: description.join(' '),
        variant: SweepNotificationVariant.Error,
      });
    }
  };

  return (
    <>
      {(env.fetchStatus === FetchStatus.Fetched ||
        (FetchStatus.Fetching === env.fetchStatus && environmentsPage)) && (
        <div className="sweep__env-action">
          <WithPermissions
            permissionStr={['create:org:fetch-job']}
            disabledTooltip={UNAUTHORIZED_FETCH_TOOLTIP}
          >
            <Button
              size="small"
              variant={environmentsPage ? 'system' : 'flat-blue'}
              onClick={refreshHandler}
              disabled={isFetching}
              loading={isFetching}
              loadingText="Refreshing..."
            >
              Refresh
            </Button>
          </WithPermissions>
        </div>
      )}

      {isFetching && !environmentsPage && <CenteredCircularProgress size={25} />}

      {hasError && !isFetching && (
        <div className="sweep__env-action">
          <WithConnectOrgPermission>
            <Button
              size="small"
              variant={environmentsPage ? 'system' : 'flat-blue'}
              onClick={reconnectHandler}
            >
              Reconnect
            </Button>
          </WithConnectOrgPermission>
        </div>
      )}
    </>
  );
};
